import React, { Component } from 'react';
import { Row, Col, Input, Icon, Checkbox, Button, Modal, message, Form } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

import './Login.css';

import { login } from '../../actions';

const FormItem = Form.Item;

class Login extends Component {
  handleForgotPassword = (e) => {
    e.preventDefault();
    const { intl } = this.props;
    Modal.info({
      title: intl.formatMessage({ id: 'Login.ForgotPassword' }),
      content: (
        <div>
          <p>
            {intl.formatMessage({ id: 'Login.ForgotPasswordMsg' })}
          </p>
        </div>
      ),
      onOk() {},
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { intl } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.login({
          data: values,
          response: {
            success: async () => {
              this.props.history.push('/dashboard');
              message.success(intl.formatMessage({ id: 'Login.SuccessMessage' }));
            },
            failure: async () => {
              message.error(intl.formatMessage({ id: 'Login.FailureMessage' }));
            },
          },
        });
      }
    });
  }

  render() {
    const { form: { getFieldDecorator }, intl } = this.props;

    return (
      <Row>
        <Col
          lg={{ span: 8, offset: 8 }}
          md={{ span: 10, offset: 7 }}
          sm={{ span: 16, offset: 4 }}
          style={{ marginTop: 50, marginBottom: 60 }}
        >
          <h1><FormattedMessage id='Login.Login' /></h1>
          <Form onSubmit={this.handleSubmit} className="login-form">
            <FormItem>
              {getFieldDecorator('lecturerId', {
                rules: [{ required: true, message: intl.formatMessage({ id: 'Login.RequireLecturerID' }) }],
              })(
                <Input
                  prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder={intl.formatMessage({ id: 'Login.LecturerID' })}
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: intl.formatMessage({ id: 'Login.RequirePassword' }) }],
              })(
                <Input
                  prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  type="password"
                  placeholder={intl.formatMessage({ id: 'Login.Password' })}
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('remember', {
                valuePropName: 'checked',
                initialValue: true,
              })(
                <Checkbox><FormattedMessage id='Login.RememberMe' /></Checkbox>
              )}
              <a onClick={this.handleForgotPassword} className="login-form-forgot" href="">
                <FormattedMessage id='Login.ForgotPassword' />
              </a>
              <Button type="primary" htmlType="submit" className="login-form-button">
                <FormattedMessage id='Login.Login' />
              </Button>
              {/* Or <a href="">register now!</a> */}
            </FormItem>
          </Form>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  isAuth: state.user.isAuth,
  loading: state.user.loading,
});

const mapDispatchToProps = {
  login,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(withRouter(injectIntl(Login))));



// WEBPACK FOOTER //
// ./src/screens/Login/Login.js